import React from 'react';
import { ShowButton, DateInput, Datagrid, DateField, TextField, Filter, TextInput } from 'react-admin';
import TList from 'cw-core-admin-ui/src/components/wrapper/TList';
import { LinkField } from 'cw-core-admin-ui/src/components/fields';
import { toApiDateTimeFormat, toJavaScriptDateFormat } from 'cw-core-admin-ui/src/components/helper/DateHelper';
import LoyaltyProgramMembershipListActions from './LoyaltyProgramMembershipListActions';

const LoyaltyProgramMembershipFilter = (props) => (
	<Filter {...props}>
		<TextInput resettable source="customerWalletId" label="resources.loyaltyProgramMemberships.filter.walletId" />
		<DateInput resettable source="fromDate" label="resources.loyaltyProgramMemberships.filter.fromDate" parse={(value) => toApiDateTimeFormat(value)} format={(value) => toJavaScriptDateFormat(value)} />
		<DateInput resettable source="untilDate" label="resources.loyaltyProgramMemberships.filter.untilDate" parse={(value) => toApiDateTimeFormat(value)} format={(value) => toJavaScriptDateFormat(value)} />
	</Filter>
);

export default (props) => (
	<TList exporter={false} create={false} {...props} loyaltyProgramId={props.filter.id} filters={<LoyaltyProgramMembershipFilter />} actions={<LoyaltyProgramMembershipListActions />}>
		<Datagrid>
			<ShowButton />
			<TextField source="id" />
			<LinkField source="walletId" type="Wallet" />
			<LinkField source="walletAccountId" type="WalletAccount" />
			<LinkField source="creator" />
			<DateField source="creationDateTime" showTime />
		</Datagrid>
	</TList>
);
